import { RightsizingSettingsV1ValidationSchema } from '../../../../_validations/rightsizing-settings-v1-validation.schema';
import { WorkloadHpaFormSettings } from '../../_constants';

export const settingsRowError: Record<
  WorkloadHpaFormSettings,
  (prop: { errors: RightsizingSettingsV1ValidationSchema }) => boolean
> = {
  basicBehavior: ({ errors }) => {
    const hpaErrors = errors?.horizontalRightsizing;
    if (!hpaErrors) return false;

    // Check V2 errors (basicBehavior)
    if (('basicBehavior' satisfies WorkloadHpaFormSettings) in hpaErrors) {
      return !!hpaErrors.basicBehavior;
    }

    return false;
  },
  metrics: ({ errors }) => {
    const hpaErrors = errors?.horizontalRightsizing;
    if (!hpaErrors) return false;

    // Check V2 errors (metrics)
    if (('metrics' satisfies WorkloadHpaFormSettings) in hpaErrors) {
      return !!hpaErrors.metrics;
    }

    return false;
  },
  autoscalerBehavior: ({ errors }) => {
    const hpaErrors = errors?.horizontalRightsizing;
    if (!hpaErrors) return false;

    // Check V2 errors (autoscalerBehavior)
    if (('autoscalerBehavior' satisfies WorkloadHpaFormSettings) in hpaErrors) {
      return !!hpaErrors.autoscalerBehavior;
    }

    return false;
  },
};
